<div class="custom-modal">
    <div class="header">
        <h1 mat-dialog-title>
            Ressalva
        </h1>
        <mat-icon mat-dialog-close="cancel">close</mat-icon>
    </div>
    <mat-divider></mat-divider>
    <div mat-dialog-content>
        <mat-card-content class="no-padding">
            <div>
                <form class="filtros-header" [formGroup]="ressalvaForm">
                    <div class="header-filter-log">

                        <div id="meRessalvaDiv">
                            <h1 class="ressalva-h1">
                                <ng-container *ngIf="modalItem.isRessalvaPorVolume === true">
                                    Essa ressalva se aplica a {{pedidoEtiquetas.length}} pedido(s).
                                </ng-container>
                                <ng-container *ngIf="modalItem.isRessalvaPorVolume !== true">
                                    Essa ressalva se aplica a {{pedidoIds.length}} pedido(s).
                                </ng-container>
                            </h1>
                            <div id="scrollable-table">
                                <table id="meRessalva" mat-table [dataSource]="meRessalvaCollection" class="table-sm">

                                    <ng-container matColumnDef="pedidoId">
                                        <th mat-header-cell *matHeaderCellDef class="text-center">Relação de NRTs</th>
                                        <td mat-cell *matCellDef="let item"
                                            class="text-center link cursor-pointer-icon">
                                            <a>{{ item.pedidoId }}</a></td>
                                    </ng-container>
                                    <ng-container matColumnDef="volumeId">
                                        <th mat-header-cell *matHeaderCellDef class="text-center">Id Volume</th>
                                        <td mat-cell *matCellDef="let item"
                                            class="text-center link cursor-pointer-icon">
                                            <a>{{ item.volumeId }}</a></td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                </table>
                            </div>
                            <div id="ressalva-fields-div">
                                <div>
                                    <mat-form-field class="ressalva-fields">
                                        <mat-label>Tipo de Ressalva</mat-label>
                                        <mat-select formControlName="tipoRessalvaId" required>
                                            <mat-option *ngFor="let item of tiposRessalva" [value]="item?.id">
                                                {{ item?.nome }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div>
                                    <mat-form-field class="ressalva-fields area-height">
                                        <mat-label>Observação</mat-label>
                                        <textarea matInput class="ressalva" type="text" maxlength="500"
                                            formControlName="observacao"></textarea>
                                    </mat-form-field>
                                </div>
                            </div>

                        </div>

                    </div>
                </form>
            </div>
        </mat-card-content>
    </div>
    <mat-divider></mat-divider>
    <div class="modal-actions" mat-dialog-actions align="end">
        <button mat-flat-button color="primary" [disabled]="!ressalvaForm.valid || isLoading === true"
            (click)="saveRessalva()">Salvar</button>
    </div>
</div>
